module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-color"
  }, [_c('div', {
    staticClass: "comments-title-container"
  }, [_c('div', {
    staticClass: "flex-space-between"
  }, [_c('div', {
    staticClass: "field add-comment-button"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "disabled": _vm.loading || _vm.video == null,
      "type": "button",
      "value": "Add Comment"
    },
    on: {
      "click": function($event) {
        _vm.toggleDisplayAddComment()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-warning",
    attrs: {
      "disabled": _vm.loading || _vm.video == null,
      "type": "button",
      "value": "Add Tag"
    },
    on: {
      "click": function($event) {
        _vm.toggleAddTag()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field search",
    class: _vm.searchFocused && 'is-active'
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "search",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.searchFocused = true
      },
      "blur": function($event) {
        _vm.searchFocused = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('AddTagModal', {
    attrs: {
      "show": _vm.showAddTagModal,
      "videoID": _vm.videoID,
      "commentID": 0,
      "currentTime": _vm.currentTime
    },
    on: {
      "close": function($event) {
        _vm.showAddTagModal = false
      }
    }
  }), _vm._v(" "), (_vm.displayAddComment) ? _c('AddComment', {
    attrs: {
      "avatar_url": _vm.user.avatar_url,
      "cycleID": _vm.cycleID,
      "videoID": _vm.videoID,
      "currentTime": _vm.currentTime
    },
    on: {
      "close": function($event) {
        _vm.closeAddComment()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.searchResults != null && _vm.searchResults.length > 0) ? _c('article', [_c('Scroll', {
    attrs: {
      "height": "82vh"
    }
  }, _vm._l((_vm.searchResults), function(comment) {
    return _c('Comment', {
      key: comment.id,
      staticClass: "mb-3 mr-2",
      attrs: {
        "cycleID": _vm.cycleID,
        "videoID": _vm.videoID,
        "userID": _vm.userID,
        "elements": comment.elements,
        "id": comment.id,
        "replies": comment.replies,
        "replies_editing": comment.replies_editing,
        "user": comment.user,
        "body": comment.body,
        "created_on": comment.created_on,
        "active": comment.active,
        "start_time": comment.start_time,
        "end_time": comment.end_time,
        "tags": comment.tags,
        "scores": comment.scores
      }
    })
  }))], 1) : (_vm.query !== '' && !_vm.loading) ? _c('p', {
    staticClass: "no-results break-word"
  }, [_vm._v("\n      No results for query "), _c('strong', [_vm._v(_vm._s(_vm.query))])]) : (!_vm.loading) ? _c('p', {
    staticClass: "nothing-message text-muted"
  }, [_vm._v("No comments yet")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-2588f836"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comments.vue
// module id = 997
// module chunks = 0